let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("l5s3n")).then(() => parcelRequire('9kLgh'));